import axios from 'axios';
import AudioCubeApiCallerInstance from '../utils/AudioCubeApiCallerInstance';
import { APP_CONSTANTS, SOUNDBOX_API_ENDPOINTS } from '../URLConstants';
import { encryptStorage } from '../CustomStorage';

export const GetAllDevices = async (
  pageNo,
  limit,
  organizationId,
  name,
  merchantDeviceId,
  phone
) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.DEVICE_LIST}?page=${pageNo}&limit=${limit}&organizationId=${organizationId}&name=${name}&merchantDeviceId=${merchantDeviceId}&phone=${phone}`
  );
  return response;
};

export const GetAllDevicesWithTrans = async (
  pageNo,
  limit,
  organizationId,
  location,
  language,
  serachBy
) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS.DEVICE_LIST_WITH_TRANS}?page=${pageNo}&limit=${limit}`,
    {
      organizationId,
      location,
      language,
      search_by: serachBy
    }
  );
  return response;
};

export const GetDeviceTransactions = async (
  organizationId,
  deviceId,
  fileterType,
  serachBy,
  pageNo,
  limit
) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS.GET_DEVICE_TRANSACTION}?page=${pageNo}&limit=${limit}`,
    {
      organizationId,
      device_id: deviceId,
      filter_type: fileterType,
      search_by: serachBy
    }
  );
  return response;
};

export const GetDeviceById = async (organizationId, deviceId) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS.GET_DEVICE_BY_ID}`,
    {
      organizationId,
      device_id: deviceId,
      language: '',
      search_by: ''
    }
  );
  return response;
};

export const DeviceEventRequestByServer = async (deviceId, DID, cmd, opts, timestamp) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS.DEVICE_LIST}/${DID}/commands`,
    [
      {
        type: 'cmd',
        value: 'action',
        timestamp,
        id: deviceId,
        cmd,
        opts,
        DID
      }
    ]
  );
  return response;
};

export const GetDeviceHeartBeat = async (deviceId) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.GET_DEVICE_HEARTBEAT,
    [deviceId]
  );
  return response;
};

export const GetHeartBeatTrend = async (deviceId, from, to, interval) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.HEARTBEAT_TREND}${deviceId}/trend?from=${from}&to=${to}&interval=${interval}`
  );
  return response;
};

export const GetButtonUsageTrend = async (deviceId, from, to) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.HEARTBEAT_TREND}${deviceId}/button-stats?startDate=${from}&endDate=${to}`
  );
  return response;
};

export const GetDeviceLiveStatus = async (deviceId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.DEVICE_LIVE_STATUS}${deviceId}`
  );
  return response;
};

export const GetSims = async (where) => {
  const response = await axios.get(
    `https://ops-api.proxgy.com/api/${SOUNDBOX_API_ENDPOINTS?.GET_SIMS}`,
    {
      params: {
        where: JSON.stringify(where)
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${encryptStorage.getItem(
          APP_CONSTANTS?.L_KEY_OF_USER_ADMIN_OPS_TOKEN
        )}`
      }
    }
  );

  return response;
};

export const GetDataUsageOfSim = async (where) => {
  const response = await axios.get(
    `https://ops-api.proxgy.com/api/${SOUNDBOX_API_ENDPOINTS?.GET_DATA_USAGE}`,
    {
      params: {
        where: JSON.stringify(where)
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${encryptStorage.getItem(
          APP_CONSTANTS?.L_KEY_OF_USER_ADMIN_OPS_TOKEN
        )}`
      }
    }
  );

  return response;
};

export const OpsLogin = async (email, password) => {
  const response = await axios.post(`https://ops-api.proxgy.com/api/v1/auth/admin/email/login/`, {
    email,
    password,

    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response;
};

export const GetGeoLocation = async (payload) => {
  const response = await axios.post(
    `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyAbybENfdyMGCPsngwnjYN2rIgIKcmsa40`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  return response;
};

export const GetAllDevicesPool = async (pageNo, limit, where) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ALL_DEVICES_POOL}?page=${pageNo}&limit=${limit}`,
    {
      params: {
        ...(where && { where: JSON.stringify(where) })
      }
    }
  );
  return response;
};

export const CreateDevice = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.GET_ALL_DEVICES_POOL,
    payload
  );
  return response;
};

export const DeviceBulkUpload = async ({ file, vendorId, lotId }) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS.DEVICE_BULK_UPLOAD}?vendorId=${vendorId}&lotId=${lotId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response;
};

export const FOTAUpdate = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.FOTA_UPDATE,
    payload
  );
  return response;
};

export const TaskUpdate = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.TASK_UPDATE,
    payload
  );
  return response;
};

export const PlayAudio = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.PLAY_AUDIO,
    payload
  );
  return response;
};

export const APNUpdate = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.APN_UPDATE,
    payload
  );
  return response;
};

export const GetDeviceDetails = async (where) => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS?.DEVICE_LIST, {
    params: {
      where: JSON.stringify(where)
    }
  });

  return response;
};

export const GetInactiveDeviceReport = async (startDate, endDate, where) => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS?.DEVICE_INACTIVE_REPORTS, {
    params: {
      where: JSON.stringify(where),
      startDate,
      endDate
    }
  });
  return response;
}
